(function (app) {

    app.provider('carrierReportsApi', [function () {
        this.$get = [
            'portalApiGateway', function (portalApiGateway) {
                var service = {};
                service.getCarrierTraining = function () {
                    return portalApiGateway.getArray('/CarrierReports/CarrierTraining');
                };

                return service;
            }
        ];
    }]);

})(window.app);